import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

const STORAGE_KEY = 'hirays_locale'

export function getDefaultLocale() {
  try {
    return localStorage.getItem(STORAGE_KEY) || 'zh'
  } catch (e) {
    return 'zh'
  }
}

export function saveLocale(locale) {
  try {
    localStorage.setItem(STORAGE_KEY, locale)
  } catch (e) { /* ignore */ }
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  fallbackLocale: 'zh',
  messages: { zh, en }
})

export default i18n
